import { Layers, LayoutList, Pencil, SlidersHorizontal } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminTestsRoutes } from './routes';
import { TEST_DESCRIPTION_FORM_TAB, TEST_EVALUATION_TAB } from './testPanels';

export const adminTestsManifest: FeatureManifest = {
  id: 'admin-tests',
  contexts: [CONTEXTS.ADMIN_TESTS, CONTEXTS.ADMIN_TEST_FORM],

  routes: [
    { routes: adminTestsRoutes, errorFallbackLabel: 'Tests techniques', guard: ADMIN_GUARD },
  ],

  centerView: {
    [CONTEXTS.ADMIN_TESTS]: lazyView(
      () => import('../views/AdminTestsListView'),
      'AdminTestsListView',
    ),
    [CONTEXTS.ADMIN_TEST_FORM]: lazyView(
      () => import('../views/AdminTestFormView'),
      'AdminTestFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_TESTS]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
          {
            id: 'admin-test-filters',
            label: 'Filtres',
            icon: SlidersHorizontal,
            view: lazyView(() => import('../views/AdminTestFiltersView'), 'AdminTestFiltersView'),
          },
        ],
        [CONTEXTS.ADMIN_TEST_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
    right: {
      tabs: {
        [CONTEXTS.ADMIN_TEST_FORM]: [
          {
            id: TEST_DESCRIPTION_FORM_TAB,
            label: 'Bloc',
            icon: Pencil,
            hideInTabBar: true,
            view: lazyView(
              () => import('../views/AdminTestDescriptionFormView'),
              'AdminTestDescriptionFormView',
            ),
          },
          {
            id: TEST_EVALUATION_TAB,
            label: 'Évaluation',
            icon: Layers,
            hideInTabBar: true,
            view: lazyView(
              () => import('../views/AdminTestEvaluationDetailView'),
              'AdminTestEvaluationDetailView',
            ),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_TESTS]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_TEST_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      // Ouvert à chaque arrivée (même s'il a été fermé à la visite précédente) :
      // sans sélection, l'onglet « Évaluation » invite à cliquer une évaluation.
      right: { open: true, defaultActiveTab: TEST_EVALUATION_TAB, reopenOnVisit: true },
    },
  },
};
